"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var mobx_1 = require("mobx");
var defaultLocale = '';
var defaultStore = {
    currentLocale: defaultLocale,
    registeredStringModules: new mobx_1.ObservableMap({}),
};
var getStore = satcheljs_1.createStore('locstrings', defaultStore);
exports.default = getStore();
